import * as d3 from 'd3'
export default {
  /*
    app_toFixed
  */
  methods: {

     app_toFixed(val, parents, child ) {

      let str = null
      
      if(parents || parents == 0) str = val.toFixed(parents)
      if(parents === null) str = val

      if(child || child == 0) str = val.toFixed(child)
      if(child === null) str = val

      return str 
    },
  

    // Mouse Events ###############################################################
    app_Link(selection, data, col) {
    
      if (!col.filter) return

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
          d3.select(this).transition().duration(50).style('opacity', .4)
        })
      .on('mouseout', function() {
        d3.select(this).transition().duration(50).style('opacity', 1)
      })
      .on('click', () => {
        this.app_Action(data, col) 
      })
    },

    app_Action(data, col) {

      let dataSource = {}

      Object.keys(this.keys).forEach(d=>{
        dataSource = {...dataSource, [d]: data[this.keys[d]]}
      })
      let filterString_ = this.filters[col.filter] || ''
      let requestText = (col.json && col.json != '') ? col.json : 'request'
      console.log(requestText, dataSource, filterString_)

      // seting request_ from A/G jsonProps
      let request_ = this.getRequestColumnProps(requestText, dataSource, this.ColumnProps)
      if(!request_) return

      if(request_.iFilters.filterString) {
        request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
      } else {
        request_.iFilters.filterString = filterString_||''
      }

      // Combine filterStrings
      request_ = {...request_,
        filters : {
          ...this.FilterValues,
          ...request_.filters,
        },
        iFilters: { 
          filterString : request_.iFilters.filterString||'',
          inputFilter : request_.iFilters.inputFilter,},
      }
      this.$emit('request-action', request_)
    },


  }
}
